import { styled } from '@mui/styles';
import Container from '@mui/material/Container';

export const StyledCheckoutForm = styled(Container)(({ theme }) => ({
	'& .OuterGrid': {
		marginTop: 1,
	},
	'& #checkoutContactSection .switch': {
		margin: 0,
	},
	'& #checkoutContactSection .MuiOutlinedInput-root': {
		borderRadius: '8px',
	},
	'& .CoverTransactionFeeSwitch': {
		marginTop: '10px',
	},
	'& .ListRadio': {
		'& .Mui-checked': {
			color: 'white',
		},
		minWidth: '40px',
	},
	'& .PaymentMethodName': {
		'& .MuiTypography-root': { fontSize: '14px' },
	},
	'& .PaymentBold': {
		'& .MuiTypography-root': { fontWeight: 600 },
	},
	'& .AmountOptions': {
		display: 'grid',
		gridTemplateColumns: 'repeat(6, 1fr)',
		columnGap: '10px',
		width: '100%',
		marginBottom: '10px',
		[theme.breakpoints.down('sm')]: {
			gridTemplateColumns: 'repeat(3, 1fr)',
			marginBottom: '20px',
			gap: '10px',
		},
	},
	'& #goodluck_div': {
		marginBottom: '15px',
	},
	'& .PaymentOptions': {
		padding: 0,

		'& .PaymentMethodIcon': {
			width: '40px', // fixed width
			minWidth: '40px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			marginRight: '8px',

			'& svg': {
				width: '30px',
				height: '30px',
			},
		},
		'& .MuiListItemButton-root': {
			display: 'flex',
			justifyContent: 'space-between',
			width: '100%',
			padding: '15px 10px',
			backgroundColor: 'transparent !important',
			transition: 'none !important',

			/* HARD stop for hover/focus/active */
			'&:hover': {
				backgroundColor: 'transparent !important',
			},
			'&:active': {
				backgroundColor: 'transparent !important',
			},
			'&:focus': {
				backgroundColor: 'transparent !important',
			},
			'&.Mui-focusVisible': {
				backgroundColor: 'transparent !important',
			},
			'&.Mui-selected': {
				backgroundColor: 'transparent !important',
			},
			'&.Mui-selected:hover': {
				backgroundColor: 'transparent !important',
			},

			/* Kill ButtonBase overlay layer */
			'&::before': {
				display: 'none',
			},

			/* Kill ripple layer completely */
			'& .MuiTouchRipple-root': {
				display: 'none !important',
			},
		},

		/* ALSO disable hover on ListItem itself */
		'& .MuiListItem-root:hover': {
			backgroundColor: 'transparent !important',
		},

		'& .ActiveOption, & .InactiveOption': {
			margin: 0,
			border: '1px solid #e0e0e0',
			backgroundColor: 'transparent',
			color: 'inherit',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'start',

			'& .MethodIcon svg': {
				filter: 'unset',
			},

			'&:not(:first-of-type)': {
				borderTop: 'none',
			},
		},

		'& > li:first-of-type': {
			borderTopLeftRadius: '10px',
			borderTopRightRadius: '10px',
		},

		'& > li:last-of-type': {
			borderBottomLeftRadius: '10px',
			borderBottomRightRadius: '10px',
		},

		'& .ActiveOption': {
			'& .Mui-checked': {
				color: theme.palette.primary.main,
			},
		},

		'& .InactiveOption': {
			borderColor: '#e0e0e0',
		},
		'& .BankTransferOuterBox': {
			width: '100%',
			padding: '0px 20px 20px 20px',
			'& .MuiOutlinedInput-root': {
				borderRadius: '8px',
			},
		},
		'& .BankTransfer': {
			backgroundColor: '#f3f2f2',
			padding: '20px',
			borderRadius: '10px',
			display: 'flex',
			flexDirection: 'column',
			gap: '15px',
			width: '100%',
			[theme.breakpoints.down('md')]: {
				padding: '20px 15px',
				border: 'none',
			},
		},
		'& .CheckCashOuterBox': {
			padding: '0px 20px 20px 20px',
			'& .MuiOutlinedInput-root': {
				borderRadius: '8px',
			},
		},
		'& .CheckCash': {
			backgroundColor: '#f3f2f2',
			padding: '20px',
			borderRadius: '10px',
			display: 'flex',
			flexDirection: 'column',
			gap: '15px',
		},
		'& .ACHComponent': {
			border: '1px solid #eee',
			padding: '20px',

			'& .ACHChooseButtons': {
				flexDirection: 'row',
				gap: '15px',
				[theme.breakpoints.down('sm')]: {
					flexDirection: 'column',
				},
			},
			'& .ACHChooseLabel': {
				textAlign: 'center',
				fontSize: '13px',
				color: 'rgba(0, 0, 0, 0.6)',
				marginBottom: '15px',
			},

			'& .ACHChoiceCard': {
				flex: 1,
				display: 'flex',
				alignItems: 'center',
				gap: '12px',
				padding: '16px',
				borderRadius: '10px',
				border: `2px solid ${theme.palette.primary.main}`,
				textAlign: 'left',
				transition: 'background-color 0.15s ease',

				'& .ACHChoiceIcon': {
					fontSize: '28px',
					flexShrink: 0,
				},

				'& .ACHChoiceTitle': {
					fontWeight: 600,
					fontSize: '14px',
					lineHeight: 1.3,
				},

				'& .ACHChoiceDescription': {
					fontSize: '12px',
					lineHeight: 1.3,
				},
			},

			'& .ACHChoiceCard--automatic': {
				backgroundColor: theme.palette.primary.main,
				color: '#fff',
				'&:hover': {
					backgroundColor: theme.palette.primary.dark,
				},
			},

			'& .ACHChoiceCard--manual': {
				backgroundColor: 'transparent',
				color: theme.palette.primary.main,
				'&:hover': {
					backgroundColor: 'rgba(0, 0, 0, 0.03)',
				},
			},
			'& .ACHHeader': {
				position: 'relative',
				alignItems: 'center',
				justifyContent: 'center',
				marginBottom: '15px',
				minHeight: '32px',

				'& .ACHBackButton': {
					position: 'absolute',
					left: 0,
					color: theme.palette.primary.main,
				},

				'& .ACHHeaderText': {
					fontWeight: 600,
					textAlign: 'center',
				},
			},
			'& .ACHManualForm': {
				backgroundColor: '#f3f2f2',
				borderRadius: '10px',
				padding: '16px',

				'& .MuiOutlinedInput-root': {
					borderRadius: '8px',
					backgroundColor: '#fff',
				},
				'& .MuiFormLabel-root': {
					fontSize: '14px',
				},
			},
			'& .ACHBankDetails': {
				flexDirection: 'row',
				justifyContent: 'space-between',
				padding: '10px',
				backgroundColor: '#eee',
				borderBottomLeftRadius: '5px',
				borderBottomRightRadius: '5px',

				'& .AccNumClass': {
					flexDirection: 'row',
					gap: '5px',
				},
			},
		},
	},
}));
